module.exports = __webpack_public_path__ + "img/distribution.f265b112.png";